import { useGLTF } from '@react-three/drei';
import * as global from "../../data/global";

export function An2(props) {
    const { nodes } = useGLTF('3ds/an/An2.gltf');
    return (
        <group {...props} dispose={null}>
            <mesh
                ref={e => {
                    if (!e) return;
                    if (!global.gw.geometries.An2) {
                        global.gw.geometries.An2 = e.geometry;
                    }
                }}
                name="An2"
                geometry={nodes.An2.geometry}
                rotation={[Math.PI / 2, 0, 0]}
                {...props.meshProps}
            />
        </group>
    );
}

useGLTF.preload('3ds/an/An2.gltf');
